
import http from './http';

export function configInfo() {
  return http.post('/config/info');
}

//广告列表
/*
type	string		0	
1首页，2直播，3赛事，4新闻，5社区，6账户  
page_size	int		15	
当前条数  
page	int		1	
当前页  
*/
export function getadvertiseList(data: { type: string; page_size?: number; page?: number }) {
  const params = new URLSearchParams();
  if (data.type) params.append('type', data.type);
  if (data.page_size) params.append('page_size', String(data.page_size));
  if (data.page) params.append('page', String(data.page));
  return http.get(`/advertise/index?${params.toString()}`);
}